module.exports = __webpack_public_path__ + "I3U1@2x.jpg?b0b0a9f27235362b455935bcd5853c33";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/I3U1@2x.jpg
// module id = 95
// module chunks = 0